"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportHeaderDTO = exports.ReportPayloadDTO = exports.GalArgumentsDTO = exports.GalEnvironment = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const enrich_by_1 = require("../decorators/enrich-by");
const gal_base_1 = require("./gal-base");
require("reflect-metadata");
const system_specs_1 = require("./system-specs");
const BASE_64_REGEX = /(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})/;
var GalEnvironment;
(function (GalEnvironment) {
    GalEnvironment["local"] = "local";
    GalEnvironment["dev"] = "dev";
    GalEnvironment["test"] = "test";
    GalEnvironment["staging"] = "stage";
    GalEnvironment["production"] = "prod";
})(GalEnvironment = exports.GalEnvironment || (exports.GalEnvironment = {}));
class GalArgumentsDTO {
    constructor() {
        Object.defineProperty(this, "publisherId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publisherGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reportingUri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "enabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "failOnReportError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabledQueue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fpEndpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "systemSpecs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "useObscureEndpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionPingIntervalMS", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disableAutoSessionHandling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
exports.GalArgumentsDTO = GalArgumentsDTO;
class ReportPayloadDTO {
    constructor() {
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "fingerprint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "localId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "gameId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "timestamp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "elapsed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "elapsedAtReportTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "systemSpecs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Gala Games User Id, while not required is highly recommended'),
    (0, decorators_1.Warning)('Gala Games specific User Id only'),
    (0, enrich_by_1.EnrichBy)([
        enrich_by_1.ENRICH_BY_META_LOOKUP.fingerprint,
        enrich_by_1.ENRICH_BY_META_LOOKUP.localId,
    ]),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "user", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User client fingerprint'),
    (0, enrich_by_1.EnrichBy)([enrich_by_1.ENRICH_BY_META_LOOKUP.localId]),
    (0, decorators_1.HideInSwagger)(),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "fingerprint", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique user identifier string'),
    (0, enrich_by_1.EnrichBy)([enrich_by_1.ENRICH_BY_META_LOOKUP.fingerprint]),
    (0, decorators_1.HideInSwagger)(),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "localId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('A field for game publishers to use allowing them to provide an id when a Gala User Id is not available.'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "gameId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.Describe)('Event timestamp'),
    (0, decorators_1.Warning)('Epoch MS, UTC'),
    (0, enrich_by_1.EnrichBy)([
        enrich_by_1.ENRICH_BY_META_LOOKUP.elapsed,
        enrich_by_1.ENRICH_BY_META_LOOKUP.elapsedAtReportTime,
    ]),
    __metadata("design:type", Number)
], ReportPayloadDTO.prototype, "timestamp", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.Describe)('Session clock when event is created, used for timestamp normalization'),
    (0, decorators_1.Warning)('Time in MS; Automated by SDKs; Manual by direct API use'),
    __metadata("design:type", Number)
], ReportPayloadDTO.prototype, "elapsed", void 0);
__decorate([
    (0, decorators_1.Describe)('Session clock when event is reported, used for timestamp normalization'),
    (0, decorators_1.Warning)('Time in MS; Automated by SDKs; Manual by direct API use'),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ReportPayloadDTO.prototype, "elapsedAtReportTime", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Previous event id'),
    (0, decorators_1.HideInSwagger)(),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "prevId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('An optional event id'),
    (0, decorators_1.Warning)('Unique at specific single event report granularity'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(GalEnvironment),
    (0, decorators_1.Describe)(`Application Working Environment: (${Object.values(GalEnvironment).join(', ')})`),
    (0, decorators_1.Example)('GalEnvironment'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "environment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('An optional unique session identifier'),
    (0, decorators_1.Warning)('Unique at specific user session granularity'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "session", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Device and OS information if available'),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => system_specs_1.SystemSpecs),
    (0, decorators_1.Example)('{ "ip": "string", "os": "string", "cpu?": "string", "gpu?":"string", "ram?":"string", "other?":"string"}'),
    __metadata("design:type", system_specs_1.SystemSpecs)
], ReportPayloadDTO.prototype, "systemSpecs", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNotEmptyObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => gal_base_1.GalBaseDTO),
    (0, decorators_1.Describe)('DTO Object specific to this event report'),
    __metadata("design:type", gal_base_1.GalBaseDTO)
], ReportPayloadDTO.prototype, "details", void 0);
exports.ReportPayloadDTO = ReportPayloadDTO;
class ReportHeaderDTO {
    constructor() {
        Object.defineProperty(this, "Authorization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(new RegExp(`bearer ${BASE_64_REGEX}`, 'i')),
    __metadata("design:type", String)
], ReportHeaderDTO.prototype, "Authorization", void 0);
exports.ReportHeaderDTO = ReportHeaderDTO;
